export default __webpack_public_path__ + "static/media/stack-organizer-logo.96e30785.svg";